import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";
import { isJson } from "../../../../../core/data/Helpers";

const INIT_STATE = {
  loading: false,
  inputs: [],
  total: 0,
  error: null
};

const route = "modules/manage/views/main/components/inputsTab/redux/slice.";

export const manageSearchInputs = createAsyncThunk(
  "manage/inputsTab/manageSearchInputs",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchInputs.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      if (!response?.data) return { items: [], total: 0 };
      return response.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageSearchInputs");
      return rejectWithValue(exc);
    }
  }
);

manageSearchInputs.query = `
              query searchInputLabels ($conditions: [InputLabelSearchInput], $sort: [InputLabelSortInput], $limit: Int, $offset: Int) {
                data: searchInputLabels (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        title
                        onLabel
                        offLabel
                    }
                    total
                }
            }
          `;

//Slice
const manageInputsTabRedux = createSlice({
  name: "manage/inputsTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchInputs
    builder.addCase(manageSearchInputs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchInputs.fulfilled, (state, action) => {
      state.loading = false;
      state.inputs = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchInputs.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageInputsTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
